// The five goal-sheet areas, as running heads through the report.
//
// The goal sheet names five areas and the advisor lead's meeting flow is
// literally "these are the five things we want to talk to you about today".
// These slim banners make the report walk that list in order, using the goal
// sheet's own words, so the summary page and the deep sections visibly belong
// to one structure.

export default function AreaHeader({ n, title }) {
  return (
    <div className="asmt-area" aria-hidden="false">
      <span className="asmt-area-n">{String(n).padStart(2, '0')}</span>
      <h2 className="asmt-area-title">{title}</h2>
    </div>
  );
}
